// import {Link} from 'react-router-dom';

import Typography from 'components/Typography';
import Modal from 'components/Modal';
import Button from 'components/Button';
import Avatar from 'components/Avatar';
import {getFullName} from 'helpers/user';
import styles from './UserModal.module.scss';
import FormGroup from 'components/FormGroup';
import TextField from 'components/TextField';
import {GooglePlaceAutoComplete} from 'components/GooglePlaceAutoComplete';
import {addressToString} from 'helpers/address';
import Edit from './Edit';
import {useHistory} from 'react-router-dom';
import useUserModal from './useUserModal';
import ConfirmationModal from 'pages/Signup/ConfirmationModal';
import {phoneFormat} from 'helpers/phoneFormat';
import {CompanyType} from 'types';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const companyTypeLabels: Record<CompanyType, string> = {
  service_provider: 'Service Provider',
  property_manager: 'Property Manager',
  delivery_manager: 'Delivery Manager',
  msp_provider: 'MSP Provider',
  pickup_dropoff: 'Reseller',
};

function UserModal({isOpen, onClose}: Props) {
  const {push} = useHistory();
  const {
    currentUser,
    register,
    logout,
    errors,
    setValue,
    getValues,
    handleCheckChanges,
    confirmationVisible,
    setConfirmationVisible,
    confirmHandler,
    sendConfirmation,
  } = useUserModal({onClose});

  return (
    <Modal className={styles.modal} isOpen={isOpen} onClose={onClose}>
      <Typography variant="h2">Profile</Typography>

      <div className={styles.root}>
        <Avatar className={styles.avatar} file={currentUser?.avatar} />
        <div className={styles.details}>
          <Typography className={styles.name} component="p" variant="h3">
            {getFullName(currentUser)}
          </Typography>
          <div className={styles.label}>
            <Typography variant="label">Email: {currentUser?.email}</Typography>
            <Typography variant="label">Phone: {currentUser?.phone}</Typography>
          </div>
        </div>
        <div
          onClick={() => {
            onClose();
            push('/details');
          }}
          className={styles.edit}
        >
          <Edit />
        </div>
      </div>
      {currentUser?.role === 'management' && (
        <>
          <Typography style={{marginTop: 50}} variant="h2">
            Company
          </Typography>
          <div>
            <FormGroup>
              <TextField
                label="Company Name"
                placeholder="Name"
                {...register('name', {
                  required: 'Required',
                })}
                error={errors.name?.message}
              />
            </FormGroup>
            {/* <FormGroup> */}
            <TextField
              label="Company type"
              disabled
              defaultValue={companyTypeLabels[currentUser?.company?.type!]}
              // value={companyTypeLabels[currentUser?.company?.type!]}
              error={errors.name?.message}
            />
            {/* </FormGroup> */}
            <FormGroup>
              <TextField
                label="Company Email"
                placeholder="Email"
                {...register('company_email', {
                  required: 'Required',
                })}
                error={errors.company_email?.message}
              />
            </FormGroup>
            <FormGroup columns={1}>
              <TextField
                label="Company Phone"
                placeholder="(123) 456-7890"
                {...register('company_phone', {
                  required: 'Required',
                  minLength: {
                    value: 14,
                    message: 'Enter a valid phone number',
                  },
                })}
                type="tel"
                onChange={(e) => {
                  let input = e.target.value.replace(/\D/g, ''); // Faqat raqamlarni qoldirish
                  e.target.value = phoneFormat(input);
                }}
                error={errors.phone?.message}
              />
            </FormGroup>
            <FormGroup columns={1}>
              <GooglePlaceAutoComplete
                label="Company Address"
                placeholder="Address"
                defaultValue={getValues().address}
                onPlaceSelected={(data) => {
                  setValue(
                    'address',
                    addressToString({
                      address_line_1: data.addressLine1,
                      city: data.city,
                      state: data.state,
                      zipcode: data.zipcode,
                      address_line_2: '',
                      is_primary: false,
                      is_valid: true,
                      label: '',
                      latitude: data.lat,
                      longitude: data.lon,
                      unit_address: '',
                      id: 0,
                      type: 'billing',
                    })
                  );
                }}
                error={errors?.address?.message}
                options={{
                  types: ['address'],
                }}
              />
            </FormGroup>

            <FormGroup columns={1}>
              <TextField
                label="Company Website"
                placeholder="https://"
                {...register('website', {
                  required: 'Required',
                })}
                error={errors.website?.message}
              />
            </FormGroup>
          </div>
        </>
      )}
      <div className={styles.buttonsContainer}>
        <Button color="danger" onClick={logout}>
          Logout
        </Button>
        {currentUser?.role === 'management' && (
          <Button color="blue" onClick={handleCheckChanges}>
            Save
          </Button>
        )}
      </div>
      <ConfirmationModal
        confirmationVisible={confirmationVisible}
        onClose={() => setConfirmationVisible(false)}
        confirmHandler={confirmHandler}
        email={getValues('email')}
        resendCode={sendConfirmation}
      />
    </Modal>
  );
}

export default UserModal;
